module.exports = __webpack_public_path__ + "img/one.90f8f403.png";